/* eslint-disable lit/attribute-value-entities */
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';

/**
 * @customElement google-map-component
 */
@Component({
  selector: 'google-map-component',
  styles: [
    css`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .map-container {
        width: 100%;
        height: 100%;
        min-height: 400px;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid #e2e8f0;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        background: #f8fafc;
      }

      .map-placeholder {
        width: 100%;
        height: 100%;
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        color: #64748b;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', sans-serif;
        font-size: 1rem;
        font-weight: 500;
      }

      .map-icon {
        width: 48px;
        height: 48px;
        margin-bottom: 16px;
        color: #0066ff;
      }

      iframe {
        width: 100%;
        height: 100%;
        border: 0;
        border-radius: 16px;
      }

      @media (max-width: 768px) {
        .map-container {
          min-height: 300px;
        }

        .map-placeholder {
          min-height: 300px;
        }
      }
    `,
  ],
  template(this: GoogleMapComponent) {
    return html`
      <div class="map-container">
        <iframe
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyArEInk4_RHHhKu33RGFwqIpcPAdu0CoEg&q=${this.address}"
          allowfullscreen
        >
        </iframe>
      </div>
    `;
  },
})
export class GoogleMapComponent extends LitElement {
  @property({ type: String })
  address = '';
}
